import { render } from "./ProductPageInfo.vue?vue&type=template&id=006e05f4"
import script from "./ProductPageInfo.vue?vue&type=script&lang=js"
export * from "./ProductPageInfo.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__